import { Routes } from '@/router/routes'

import { AppPermissions } from '@/types/enums/permissions/permissions'
import { Middleware } from '@/types/enums/middleware/middleware'

export const timesheetRoutes = [
  {
    path: '/timesheet',
    name: Routes.Timesheet,
    component: () => import('@/pages/contexts/portal/timesheet/Index.vue'),
    meta: {
      pageTitle: 'My Timesheet',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
    },
  },
  {
    path: '/timesheets',
    name: Routes.UserTimesheets,
    component: () => import('@/pages/contexts/portal/timesheets/Index.vue'),
    meta: {
      pageTitle: 'Team Member Timesheets',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.MANAGE_TIMESHEETS,
    },
  },
  {
    path: '/timesheets/:userId',
    name: Routes.UserTimesheet,
    component: () => import('@/pages/contexts/portal/timesheets/_userId/Index.vue'),
    meta: {
      pageTitle: 'Team Member Timesheets',
      middleware: [
        Middleware.REQUIRES_AUTH,
        Middleware.TOGGLES_NAV_DRAWER,
      ],
      permission: AppPermissions.MANAGE_TIMESHEETS,
    },
  },
]
